// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H6VL05lXT8RBEeYRT2Qd {
  position: relative;
  margin: auto auto;
}

.Lec_eQUTLn6PMETJyGZK {
  display: flex;
  margin: auto;
}
.Lec_eQUTLn6PMETJyGZK .JmrBuGFQW1METmy8PeVg {
  animation: hOAQJ4tf8zYNUXZBVTBx 2s linear infinite;
}
@keyframes hOAQJ4tf8zYNUXZBVTBx {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.ztFgcL8RcloF0t5Czh2o {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-width: 500px;
  row-gap: 28px;
  padding: 0px 14px 0px 4px;
}
.ztFgcL8RcloF0t5Czh2o .XEehcqL5rHqHu91YCRbf {
  position: absolute;
  top: 22px;
  left: 40px;
  font-size: 24px !important;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  margin-top: 8px;
  width: 100%;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .SDCwiDhuUjAM3A7suSvd,
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .E_HgW78SD_n3lYgjSK7Q,
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .Vg96b3RvCD33FiMZNQzS {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .TPlgvS2EneRdA5XnfGXe {
  font-size: 16px !important;
  font-weight: 600;
  text-transform: uppercase;
  color: #b6b6b6;
  letter-spacing: 0.5px;
  margin: 0;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo .n2uUbpa0X3fxHajwOWQh {
  display: flex;
  column-gap: 16px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo .n2uUbpa0X3fxHajwOWQh img {
  width: 100px;
  height: 100px;
  border-radius: 78px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo .n2uUbpa0X3fxHajwOWQh .PWo9ENk4M_RnhSyKq_vA {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: center;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo .n2uUbpa0X3fxHajwOWQh .PWo9ENk4M_RnhSyKq_vA .nXtP8H0HkxxAGGxZOLuw {
  font-size: 20px;
  font-weight: 400;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo .n2uUbpa0X3fxHajwOWQh .PWo9ENk4M_RnhSyKq_vA .SoMlrRShGasGXioQipxA {
  font-size: 20px;
  font-weight: 400;
  color: #b6b6b6;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .OpY3dZlhj8yy7uOr4KKo .RdunAb4OBiPhh8gquW8b {
  border-radius: 18px;
  background: none;
  color: #774dee !important;
  border: 1px solid #774dee !important;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .ePWgsC9_l8VHJEPBFoit {
  margin: 8px 0 4px 0;
  border-top: 1px solid rgb(92, 92, 92) !important;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .fQFR1iFUWDyuCy7FHHjd .VvDRQQfyWXyiVJ8OgZgT {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b6b6b6;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .fQFR1iFUWDyuCy7FHHjd .VvDRQQfyWXyiVJ8OgZgT .JmrBuGFQW1METmy8PeVg {
  width: 20px;
  height: 20px;
  animation: hOAQJ4tf8zYNUXZBVTBx 1s linear infinite;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .V7lg2XiKlfkMqlp8Ev2G {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .V7lg2XiKlfkMqlp8Ev2G > p {
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 18px !important;
  margin: 0;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .V7lg2XiKlfkMqlp8Ev2G .JBHyxo94jS663KArw9RQ {
  font-size: 14px !important;
  font-style: italic;
  color: #b6b6b6;
  margin: 0;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .iNPk9VRqcxo95MgEu7WU {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .iNPk9VRqcxo95MgEu7WU > p {
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-size: 18px !important;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .iNPk9VRqcxo95MgEu7WU .lrXOBSXOvoiA8el_5FSu {
  padding: 0 !important;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .f2U0O0JggpkqtNNEvEE3 {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  background-color: #8965ef;
  border-radius: 8px;
  padding: 12px 16px;
  max-width: 456px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .f2U0O0JggpkqtNNEvEE3 > span {
  font-weight: 400;
  font-size: 14px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .f2U0O0JggpkqtNNEvEE3 .hsLkI42Tv2lq1XrkJWWp {
  display: flex;
  flex-direction: column;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .f2U0O0JggpkqtNNEvEE3 .hsLkI42Tv2lq1XrkJWWp .lAQbMXyQT8G8i28asiYq {
  font-weight: 600;
  font-size: 16px;
  margin: 0;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .f2U0O0JggpkqtNNEvEE3 .hsLkI42Tv2lq1XrkJWWp > span {
  font-weight: 400;
  font-size: 14px;
}
.ztFgcL8RcloF0t5Czh2o .whdh9w9FRNLBGGuRr0Sh .f2U0O0JggpkqtNNEvEE3 .jtkNH9brcaMFbjyJDqig {
  display: flex;
  column-gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/ProfileModal/ProfileModal.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;AAAF;AAEE;EACE,kDAAA;AAAJ;AAGE;EACE;IACE,uBAAA;EADJ;EAIE;IACE,yBAAA;EAFJ;AACF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAHF;AAKE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;AAHJ;AAME;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAJJ;AAMI;;;EAGE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAJN;AAOI;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,cCvCU;EDwCV,qBAAA;EACA,SAAA;AALN;AAQI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AANN;AAQM;EACE,aAAA;EACA,gBAAA;AANR;AAQQ;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AANV;AASQ;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;AAPV;AASU;EACE,eAAA;EACA,gBAAA;AAPZ;AAUU;EACE,eAAA;EACA,gBAAA;EACA,cC1EI;ADkEhB;AAaM;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;AAXR;AAeI;EACE,mBAAA;EACA,gDAAA;AAbN;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cCjGQ;ADkFhB;AAiBQ;EACE,WAAA;EACA,YAAA;EACA,kDAAA;AAfV;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlBN;AAoBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,SAAA;AAlBR;AAqBM;EACE,0BAAA;EACA,kBAAA;EACA,cC3HQ;ED4HR,SAAA;AAnBR;AAuBI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AArBN;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AArBR;AAwBM;EACE,qBAAA;AAtBR;AA0BI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAzBN;AA2BM;EACE,gBAAA;EACA,eAAA;AAzBR;AA4BM;EACE,aAAA;EACA,sBAAA;AA1BR;AA4BQ;EACE,gBAAA;EACA,eAAA;EACA,SAAA;AA1BV;AA6BQ;EACE,gBAAA;EACA,eAAA;AA3BV;AA+BM;EACE,aAAA;EACA,gBAAA;AA7BR","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `H6VL05lXT8RBEeYRT2Qd`,
	"loadingSpinner": `Lec_eQUTLn6PMETJyGZK`,
	"spinner": `JmrBuGFQW1METmy8PeVg`,
	"spin": `hOAQJ4tf8zYNUXZBVTBx`,
	"contentWrapper": `ztFgcL8RcloF0t5Czh2o`,
	"title": `XEehcqL5rHqHu91YCRbf`,
	"content": `whdh9w9FRNLBGGuRr0Sh`,
	"authSection": `SDCwiDhuUjAM3A7suSvd`,
	"publicProfileSection": `E_HgW78SD_n3lYgjSK7Q`,
	"subscriptionSection": `Vg96b3RvCD33FiMZNQzS`,
	"sectionTitle": `TPlgvS2EneRdA5XnfGXe`,
	"authInfo": `OpY3dZlhj8yy7uOr4KKo`,
	"profile": `n2uUbpa0X3fxHajwOWQh`,
	"credentials": `PWo9ENk4M_RnhSyKq_vA`,
	"name": `nXtP8H0HkxxAGGxZOLuw`,
	"email": `SoMlrRShGasGXioQipxA`,
	"logOut": `RdunAb4OBiPhh8gquW8b`,
	"divider": `ePWgsC9_l8VHJEPBFoit`,
	"usernameSection": `fQFR1iFUWDyuCy7FHHjd`,
	"loadingUsername": `VvDRQQfyWXyiVJ8OgZgT`,
	"tokenUsage": `V7lg2XiKlfkMqlp8Ev2G`,
	"tokenDescription": `JBHyxo94jS663KArw9RQ`,
	"manageBillingCard": `iNPk9VRqcxo95MgEu7WU`,
	"manageSubscription": `lrXOBSXOvoiA8el_5FSu`,
	"subscribeCard": `f2U0O0JggpkqtNNEvEE3`,
	"about": `hsLkI42Tv2lq1XrkJWWp`,
	"cardTitle": `lAQbMXyQT8G8i28asiYq`,
	"controlButtons": `jtkNH9brcaMFbjyJDqig`
};
export default ___CSS_LOADER_EXPORT___;
